import React from 'react';
import { useSelector } from 'react-redux';

import Header from '../../components/Header';
import Title from '../../components/Title';
import Text from '../../components/Text';
import Line from '../../components/Line';
import Card from './Card';
import Actions from '../../components/Actions';
import MobileMenuHeader from '../../components/MobileMenuHeader';

export default function Summary(props) {
  const {
    nextClickHandler,
    menuItems,
    selectComponent,
    componentIndex,
    rules,
    backPath,
    locales,
    locales: {
      common,
      tipCustomerSegment,
      channel: {
        name,
        summary: { header, title, text },
        intro: { card },
      },
    },
  } = props;
  const { collection } = useSelector((state) => state.channel);

  return (
    <section className="bmc-page" aria-label={header}>
      <Header
        title={header}
        subtitle={name}
        icon="icon-channel"
        locales={locales}
        componentIndex={componentIndex}
        tipLocales={tipCustomerSegment}
        menuItems={menuItems}
        onMenuItemClick={selectComponent}
        rules={rules}
        backPath={backPath}
        mobileMenuHeader={
          <MobileMenuHeader icon="ChannelsCanvas" title={name} color="green" />
        }
      />

      <Text align="center">{[text[0]]}</Text>

      <Line />

      <Title text={title[0]} className="margin-top-60" />

      {collection.map((channel) => (
        <Card
          locales={locales}
          className="margin-top-60 margin-wide-40-lg"
          card={{ ...card, ...channel, title: null }}
          key={channel.id}
          dropzoneMode
        />
      ))}

      <Actions nextClickHandler={nextClickHandler} buttonName={common.done} />
    </section>
  );
}
